<template>
  <div>
    <Header />
    <div class="pageTitle">Profile</div>
    <div class="whiteBox whiteBoxProfile" v-if="currentUser && userInfoLoaded">
      <div class="pageSubTitle">Profile</div>
      <div class="profileAvatar" v-bind:style="{ backgroundImage: `url(${photoURL})` }">
        <div v-if="!photoURL" class="profileAvatar_name">{{String(userInfo.name).substring(0,1)}}</div>
        <div v-if="loading.image" class="profileAvatar_loader"></div>
        <div v-if="!loading.image" class="profileAvatar_hover">Change</div>
        <input v-if="!loading.image" @change="uploadFile($event.target.files)" type="file" accept="image/*" />
      </div>
      <table class="profile_table">
        <tr>
          <td>Name</td>
          <td>{{ userInfo.name }}</td>
          <td>
            <button
              class="button button_cancel"
              @click="
                () => {
                  activeModal.unshift('editDisplayName');
                  this.displayName = userInfo.name;
                }
              "
            >
              Edit
            </button>
          </td>
        </tr>
        <tr>
          <td>Email</td>
          <td>{{ currentUser.email }}</td>
          <td>
            <button
              class="button button_cancel"
              @click="
                () => {
                  activeModal.unshift('editEmail');
                  email = currentUser.email;
                  error.email = '';
                }
              "
            >
              Edit
            </button>
          </td>
        </tr>
        <tr>
          <td>Password</td>
          <td>
            ••••••••••••
          </td>
          <td>
            <button
              class="button button_cancel"
              @click="
                () => {
                  activeModal.unshift('editPassword');
                }
              "
            >
              Edit
            </button>
          </td>
        </tr>
      </table>
    </div>

    <div class="whiteBox whiteBoxProfileNotification">
      <div class="pageSubTitle">Notifications</div>
      <label class="checkbox">
        <input type="checkbox" v-model="userInfo.notifications" @click="setNotifications" />
        <b></b>
        Receive email notifications when someone @ mentions you
      </label>
    </div>

    <div class="popup_shadow" @click="hideFirstModal" v-if="activeModal.length"></div>

    <Popup v-if="activeModal[0] === 'editDisplayName'">
      <template v-slot:fields>
        <label>Name</label>
        <input
          v-model="displayName"
          type="text"
          @keyup="
            () => {
              error.displayName = '';
            }
          "
        />
        <div v-if="error.displayName !== ''" class="error-msg">
          {{ error.displayName }}
        </div>
      </template>

      <template v-slot:buttons>
        <button class="button button_cancel" @click="hideFirstModal">Cancel</button>
        <button v-bind:class="[loading.displayName ? 'loading loading-center' : '', 'button button_ok']" @click="saveDisplayName">Save changes</button>
      </template>
    </Popup>

    <Popup v-if="activeModal[0] === 'editEmail'">
      <template v-slot:fields>
        <label>Email address</label>
        <input v-model="email" type="text" />
        <div v-if="error.email !== ''" class="error-msg">
          {{ error.email }}
        </div>
      </template>

      <template v-slot:buttons>
        <button class="button button_cancel" @click="hideFirstModal">Cancel</button>
        <button class="button button_ok" @click="saveEmail">Save changes</button>
      </template>
    </Popup>

    <Popup v-if="activeModal[0] === 'editPassword'">
      <template v-slot:fields>
        <label>New Password</label>
        <input v-model="password" placeholder="••••••••••••" type="password" />
        <div v-if="error.password !== ''" class="error-msg">
          {{ error.password }}
        </div>
      </template>

      <template v-slot:buttons>
        <button class="button button_cancel" @click="hideFirstModal">Cancel</button>
        <button class="button button_ok" @click="savePassword">Save changes</button>
      </template>
    </Popup>

    <Popup v-if="activeModal[0] === 'confirmCredentials'" title="Please Confirm your Current Password">
      <template v-slot:fields>
        <label>Email address</label>
        <input type="text" disabled v-bind:value="currentUser.email" />
        <label>Password</label>
        <input v-model="cred.password" type="password" />

        <div v-if="error.cred !== ''" class="error-msg">
          {{ error.cred }}
        </div>
      </template>

      <template v-slot:buttons>
        <button
          class="button button_cancel"
          @click="
            () => {
              hideFirstModal();
            }
          "
        >
          Cancel
        </button>
        <button v-bind:class="[credentialsLoading ? 'loading loading-center' : '', 'button button_ok']" @click="reauthenticate">Save changes</button>
      </template>
    </Popup>

    <Popup v-show="activeModal[0] === 'addCard'" title="Add Card" class="popup_addCard">
      <template v-slot:fields>
        <div class="pay_number">
          <div id="card-number-element" class="input"></div>
        </div>
        <div class="pay_otherDetails">
          <div id="card-expiry-element" class="input"></div>
          <div id="card-cvc-element" class="input"></div>
        </div>
      </template>

      <template v-slot:buttons>
        <button class="button button_cancel" @click="hideFirstModal">Cancel</button>
        <button v-bind:class="[loading.newCard ? 'loading loading-center' : '', 'button button_ok']" @click="sendNewCard">Send</button>
      </template>
    </Popup>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from '../elements/Header.vue';
import Popup from '../elements/Popup.vue';
import * as firebase from 'firebase';
import firebaseFirestore, { AUTH, STORAGE, ANALYTICS } from 'src/firebase-config';
import db from '../../firebase-config';
import mixins from 'src/mixins.js';
import _get from 'lodash.get';
export default {
  mixins: [mixins],
  components: { Header, Popup },
  data() {
    return {
      credentialsLoading: false,
      credentialsConfirm: '',
      email: '',
      displayName: '',
      password: '',
      activeModal: [],
      cred: {
        password: '',
        finished: false
      },
      loading: {
        displayName: false,
        image: false,
        newCard: false,
        defaultCard: '',
        deleteCard: ''
      },
      error: {
        cred: '',
        displayName: '',
        email: '',
        password: ''
      },
      succPassword: ''
    };
  },
  computed: {
    ...mapState(['userInfo', 'userInfoLoaded', 'workspaces', 'currentUser', 'currentWorkspace', 'workspaceLoaded']),
    photoURL: function () {
      return this.userInfo.photoURL;
    },
    subscribedWorkspaces: function () {
      return _get(this.userInfo, 'billing.subscribedWorkspaces', []);
    }
  },
  methods: {
    reauthenticate() {
      this.credentialsLoading = true;
      const credential = firebase.auth.EmailAuthProvider.credential(this.currentUser.email, this.cred.password);

      return AUTH.currentUser
        .reauthenticateWithCredential(credential)
        .then(() => {
          if (this.credentialsConfirm === 'email') {
            AUTH.currentUser
              .updateEmail(this.email)
              .then(() => {
                this.saveFinish();
                AUTH.currentUser.reload().then(() => {
                  this.$store.commit('setCurrentUser', firebase.auth().currentUser);
                });
              })
              .catch((err) => {
                this.cred.password = '';
                this.credentialsLoading = false;
                this.hideFirstModal();
                console.log(err);
                this.error.email = err.message;
              });
          }

          if (this.credentialsConfirm === 'password') {
            AUTH.currentUser
              .updatePassword(this.password)
              .then(() => {
                this.saveFinish();
                AUTH.currentUser.reload().then(() => {
                  this.$store.commit('setCurrentUser', firebase.auth().currentUser);
                  this.$toasted.show('Password successfully changed', { type: 'success' });
                });
              })
              .catch((err) => {
                this.cred.password = '';
                this.credentialsLoading = false;
                this.hideFirstModal();
                console.log(err);
                this.error.password = err.message;
              });
          }
        })
        .catch((err) => {
          this.credentialsLoading = false;
          console.log(err);
          this.error.cred = err.message;
        });
    },
    saveFinish() {
      this.cred.password = '';
      this.credentialsLoading = false;
      this.hideFirstModal();
      this.hideFirstModal();
    },
    saveEmail() {
      if (this.email === this.currentUser.email) {
        return this.saveFinish();
      }
      this.credentialsConfirm = 'email';
      this.error.cred = '';
      this.activeModal.unshift('confirmCredentials');
    },
    savePassword() {
      this.credentialsConfirm = 'password';
      this.error.cred = '';
      this.activeModal.unshift('confirmCredentials');
    },
    saveDisplayName() {
      if (!this.displayName) {
        return (this.error.displayName = 'Please fill Name field');
      }
      this.loading.displayName = true;

      firebaseFirestore
        .collection('usersInfo')
        .doc(this.currentUser.uid)
        .set(
          {
            name: this.displayName
          },
          { merge: true }
        )
        .then(() => {
          this.loading.displayName = false;
          this.hideFirstModal();
          this.$toasted.show('Name successfully changed', { type: 'success' });
        })
        .catch((err) => {
          console.log(err);
          this.error.displayName = err.message;
        });
    },
    uploadFile(file) {
      if (!file[0]) return;
      this.loading.image = true;
      const filename = AUTH.currentUser.email.replace('.', '-').replace('@', '-');
      let uploadTask = STORAGE.ref('/img/user-logo/' + filename).put(file[0], { cacheControl: 'public,max-age=31536000', contentType: 'image/jpeg' });
      uploadTask.on(
        'state_changed',
        () => {},
        null,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((userLogoSrc) => {
            firebaseFirestore.collection('usersInfo').doc(this.currentUser.uid).update({ photoURL: userLogoSrc })
              .then(() => {
                ANALYTICS.logEvent('user_avatar_updated',{
                  email:AUTH.currentUser.email,
                });
                this.loading.image = false;
              });
          });
        }
      );
    },
    sendNewCard() {
      this.loading.newCard = true;

      window.stripe.createToken(this.cardNumberElement).then((response) => {
        const { token } = response;
        if (response.error) {
          this.errorMsg = response.error.message;
        } else {
          firebase
            .firestore()
            .collection('usersInfo')
            .doc(`${this.currentUser.uid}`)
            .update({
              'billing.tokens': firebase.firestore.FieldValue.arrayUnion(token.id)
            })
            .then(() => {
              this.loading.newCard = false;
              this.hideFirstModal();
              this.$toasted.show('New card successfully added', { type: 'success' });
            });
        }
      });
    },
    setDefaultCard(cardId) {
      this.loading.defaultCard = cardId;
      db.collection('usersInfo')
        .doc(this.currentUser.uid)
        .update({
          stripeAction: {
            type: 'setDefaultCard',
            payload: {
              id: cardId
            }
          }
        })
        .then(() => {
          this.$toasted.show('Default card changed', { type: 'success' });
          this.loading.defaultCard = '';
        });
    },
    setNotifications() {
      db.collection('usersInfo')
        .doc(this.currentUser.uid)
        .update({
          notifications: !this.userInfo.notifications
        })
    },
    deleteCard(cardId) {
      this.loading.deleteCard = cardId;
      db.collection('usersInfo')
        .doc(this.currentUser.uid)
        .update({
          stripeAction: {
            type: 'deleteCard',
            payload: {
              id: cardId
            }
          }
        })
        .then(() => {
          this.$toasted.show('Card deleted', { type: 'success' });
          this.loading.deleteCard = '';
        });
    },
    userInfoCheck: function () {
      this.subscribeAllWorkspacesMixin();
    },
    workspacesCheck: function () {
      this.setCurrentWorkspaceMixin();
    }
  },
  mounted() {
    ANALYTICS.logEvent('page_view');
  }
};
</script>
